// Custom events have been added to the theme to make adding
// custom functionality easier. The below events have been
// exposed as well as the associated data for each event.
// To enable this functionality update the 'useCustomEvents' variable in
// the theme.liquid file to 'true'.

// This event fires whenever an item has been added to the cart.
// This event is exposed when the ajax cart is enabled.
// The product object is passed within the detail object.
document.addEventListener("cart:item-added", function (evt) {});

// This event fires whenever the cart is updated.
// This event is exposed when the ajax cart is enabled.
// The cart object is passed within the detail object.
document.addEventListener("cart:updated", function (evt) {});

// This event fires whenever there is an error when adding an item to the cart.
// This error is typically due to a product not having sufficient stock.
// The error message is passed within the detail object.
document.addEventListener("cart:error", function (evt) {});

// This event fires whenever the quick cart is opened.
// This event is exposed when the ajax cart is enabled.
// The cart object is passed within the detail object.
document.addEventListener("quick-cart:open", function (evt) {});

// This event fires whenever the quick cart is opened.
// This event is exposed when the ajax cart is enabled.
document.addEventListener("quick-cart:close", function () {});

// This event fires whenever a variant product is selected.
// This event is exposed when a 'Variant selectors' block has been added to
// a product template or featured product section
// The selected variant object is passed within the detail object.
document.addEventListener("product:variant-change", function (evt) {
  const variant = evt.detail.variant;

  try {
    handleProductVariantChanged(variant);
  } catch (e) {
    console.error(e);
  }
});

// This event fires whenever a product quanatiy is updated.
// This event is exposed when a 'Quantity selector' block has been added to
// a product template or featured product section
// The quantity and selected variant object is passed within the detail object.
document.addEventListener("product:quantity-update", function (evt) {});

// This event fires whenever quickview modal is opened.
// This event is exposed when the 'Enable quick view' feature is enabled
// And a quick view modal is opened.
document.addEventListener("quickview:loaded", function () {});

// Keep dropdown choices in sync with the availability of the complete variant
// combination. This is especially important for Shopify bundle products, whose
// availability is determined by the inventory of their component products.
const initializedVariantDropdowns = new WeakSet();

function initializeVariantDropdownAvailability(scope = document) {
  scope
    .querySelectorAll(
      '.product__variants-wrapper--bundle[data-enable-dynamic-product-options="true"]' +
      ':has(> [data-product-option] > .select-wrapper)' +
      ':not(:has(> [data-product-option] > [data-option-buttons]))'
    )
    .forEach(function (wrapper) {
      if (initializedVariantDropdowns.has(wrapper)) return;

      const variantJson = wrapper.querySelector("[data-variant-json]");
      const productOptions = Array.from(
        wrapper.querySelectorAll(":scope > [data-product-option]")
      );
      const selects = productOptions
        .map(function (productOption) {
          return productOption.querySelector(
            ':scope > .select-wrapper > select[name^="options["]'
          );
        })
        .filter(Boolean);

      if (
        !variantJson ||
        selects.length === 0 ||
        selects.length !== productOptions.length
      ) return;

      let variants;

      try {
        variants = JSON.parse(variantJson.textContent);
      } catch (error) {
        console.error("Could not read product variant availability.", error);
        return;
      }

      const productContainer = wrapper.closest(".product__top, .quick-product");
      const soldOutElement = productContainer
        ? productContainer.querySelector("[data-lang-sold-out]")
        : null;
      const soldOutLabel = soldOutElement
        ? soldOutElement.dataset.langSoldOut
        : "Sold out";

      function updateDropdownAvailability() {
        const selectedOptions = selects.map(function (select) {
          return select.value;
        });

        selects.forEach(function (select, optionIndex) {
          Array.from(select.options).forEach(function (option) {
            const optionIsAvailable = variants.some(function (variant) {
              if (!variant.available || variant.options[optionIndex] !== option.value) {
                return false;
              }

              return selectedOptions.every(function (selectedValue, selectedIndex) {
                return selectedIndex === optionIndex ||
                  variant.options[selectedIndex] === selectedValue;
              });
            });

            option.disabled = !optionIsAvailable;

            const soldOutSuffix = ` — ${soldOutLabel}`;
            const baseLabel = option.textContent.endsWith(soldOutSuffix)
              ? option.textContent.slice(0, -soldOutSuffix.length)
              : option.textContent;

            option.textContent = optionIsAvailable
              ? baseLabel
              : `${baseLabel}${soldOutSuffix}`;
          });
        });
      }

      selects.forEach(function (select) {
        select.addEventListener("change", updateDropdownAvailability);
      });

      initializedVariantDropdowns.add(wrapper);
      updateDropdownAvailability();
    });
}

document.addEventListener("DOMContentLoaded", function () {
  initializeVariantDropdownAvailability();
});

document.addEventListener("shopify:section:load", function (event) {
  initializeVariantDropdownAvailability(event.target);
});

document.addEventListener("quickview:loaded", function () {
  initializeVariantDropdownAvailability();
});
